import Container from 'typedi';
import Vue from 'vue';
import Vuex from 'vuex';
import { version } from '../../package.json';

Vue.use(Vuex);

function getCookieValue(name) {
  if (typeof document === 'undefined') {
    return null;
  }
  const cookies = document.cookie ? document.cookie.split('; ') : [];
  for (const cookie of cookies) {
    const [key, ...valueParts] = cookie.split('=');
    if (key === name) {
      return decodeURIComponent(valueParts.join('='));
    }
  }
  return null;
}

function getPersistedValue(key) {
  const localValue = typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null;
  return localValue || getCookieValue(key) || '';
}

export default new Vuex.Store({
  state: {
    appVersion: version,
    session: false,
    accessToken: '',
    refreshToken: '',
    dateToken: null,
    urlDocumentationTroncal:
      'https://documenter.getpostman.com/view/20397665/2sAY4shiNk#32bfc663-21de-431b-95b4-1e6a93474e2d',
    urlDocumentationRoutePlanner: 'https://documenter.getpostman.com/view/39289113/2sAY4uEPpK',
    idVehicleTypeDefault: process.env.VUE_APP_ID_VEHICLE_TYPE,
    urlWidget: process.env.VUE_APP_WIDGET_URL,
    urlLogin: process.env.VUE_APP_LOGIN_URL,
    urlWebSocket: process.env.VUE_APP_WEB_SOCKET_URL,
    urlCartaPorte: process.env.VUE_APP_CARTA_PORTE,
    urlFacturama: process.env.VUE_APP_API_FACTURAMA,
    urlSolver: process.env.VUE_APP_SOLVER_URL,
    urlWebSocketRealTimeRoute: process.env.VUE_APP_WEB_SCOKET_REAL_TIME_URL,
    urlAPI: process.env.VUE_APP_API_URL,
    urlFront: process.env.VUE_APP_FRONT_URL,
    urlImage: process.env.VUE_APP_IMAGE_URL,
    urlCatalogoSat: process.env.VUE_APP_URL_CATALOGO_SAT,
    urlHistoryRoute: process.env.VUE_APP_HISTORY_ROUTE_URL,
    urlSimpleLogin: process.env.VUE_APP_SIMPLE_LOGIN_URL,
    apiKey: process.env.VUE_APP_GMAP_API_KEY,
    urlWebhook: process.env.VUE_APP_INTEGRATION_URL,
    clientId: null,
    introspect: process.env.VUE_APP_INTROSPECT,
    local: location.hostname === 'localhost' || location.hostname === '127.0.0.1',
    permissionsUrl: process.env.VUE_APP_PERMISSIONS_URL,
    idRouteFlash: null,
    shortCutPathOrigin: null,
    permissionUser: null,
    dataAccess: null,
    isUserReady: false,
    clientApiKey: '',
    clientName: '-',
    client: null,
    dateFilterFromRouteboard: null,
    dateFilterDuringRouteboard: null,
    loggedUser: null,
    routeBoardVehicleFilter: null,
    routeBoardDriverFilter: null,
    routeBoardOriginFilter: null,
    routeBoardDestinationFilter: null,
    routeBoardRouteNameFilter: null,
    routeBoardRouteStatusFilter: null,
    routeBoardRouteIdFilter: null,
    routeBoardDocumentNumberFilter: null,
    initDateFrom: null,
    initDateTo: null,
    timeZone: null,
    newEvent: null,
    notificationConfig: true,
    soundConfig: false,
    notificationWebConfig: true,
    soundConfigWebNotification: false,
    routeDetailCounter: 0,
    firstTimeRefresh: true,
    isBasicUser: false,
    maxSpeedNotification: true,
    doorOpeningNotification: true,
    exDetentionNotification: true,
    routeDepartureNotification: true,
    panicNotification: true,
    interfNotification: true,
    disconnNotification: true,
    gpsLossNotification: true,
    speedNotification: true,
    subscriptionEndAt: null,
    userId: null,
    jsonDataPlanification: null,
    optimizationBody: null,
    optimizationResult: null,
    inputOptimization: null,
    outputOptimization: null,
    vehicles: [],
    jsessionid: getPersistedValue('JSESSIONID'),
    wpsid: getPersistedValue('wpsid'),
  },
  getters: {
    appVersion: (state) => state.appVersion,
    session: (state) => state.session,
    accessToken: (state) => state.accessToken,
    refreshToken: (state) => state.refreshToken,
    dateToken: (state) => state.dateToken,
    idVehicleTypeDefault: (state) => state.idVehicleTypeDefault,
    urlCartaPorte: (state) => state.urlCartaPorte,
    urlFacturama: (state) => state.urlFacturama,
    urlWebSocket: (state) => state.urlWebSocket,
    urlSolver: (state) => state.urlSolver,
    urlWebSocketRealTimeRoute: (state) => state.urlWebSocketRealTimeRoute,
    urlDocumentationTroncal: (state) => state.urlDocumentationTroncal,
    urlDocumentationRoutePlanner: (state) => state.urlDocumentationRoutePlanner,
    urlWidget: (state) => state.urlWidget,
    urlLogin: (state) => state.urlLogin,
    urlImage: (state) => state.urlImage,
    urlCatalogoSat: (state) => state.urlCatalogoSat,
    urlFront: (state) => state.urlFront,
    urlRecover: (state) => state.urlRecover,
    subscriptionEndAt: (state) => state.subscriptionEndAt,
    urlHistoryRoute: (state) => state.urlHistoryRoute,
    urlSimpleLogin: (state) => state.urlSimpleLogin,
    apiKey: (state) => state.apiKey,
    clientId: (state) => state.clientId,
    userId: (state) => state.userId,
    urlAPI: (state) => state.urlAPI,
    urlWebhook: (state) => state.urlWebhook,
    introspect: (state) => state.introspect,
    permissionsUrl: (state) => state.permissionsUrl,
    local: (state) => state.local,
    idRouteFlash: (state) => state.idRouteFlash,
    shortCutPathOrigin: (state) => state.shortCutPathOrigin,
    permissionUser: (state) => state.permissionUser,
    dataAccess: (state) => state.dataAccess,
    isUserReady: (state) => state.isUserReady,
    clientApiKey: (state) => state.clientApiKey,
    dateFilterFromRouteboard: (state) => state.dateFilterFromRouteboard,
    dateFilterDuringRouteboard: (state) => state.dateFilterDuringRouteboard,
    clientName: (state) => state.clientName,
    client: (state) => state.client,
    loggedUser: (state) => state.loggedUser,
    initDateFrom: (state) => state.initDateFrom,
    initDateTo: (state) => state.initDateTo,
    routeBoardVehicleFilter: (state) => state.routeBoardVehicleFilter,
    routeBoardDriverFilter: (state) => state.routeBoardDriverFilter,
    routeBoardOriginFilter: (state) => state.routeBoardOriginFilter,
    routeBoardDestinationFilter: (state) => state.routeBoardDestinationFilter,
    routeBoardRouteNameFilter: (state) => state.routeBoardRouteNameFilter,
    routeBoardRouteStatusFilter: (state) => state.routeBoardRouteStatusFilter,
    routeBoardRouteIdFilter: (state) => state.routeBoardRouteIdFilter,
    routeBoardDocumentNumberFilter: (state) => state.routeBoardDocumentNumberFilter,
    timeZone: (state) => state.timeZone,
    newEvent: (state) => state.newEvent,
    notificationConfig: (state) => state.notificationConfig,
    soundConfig: (state) => state.soundConfig,
    notificationWebConfig: (state) => state.notificationWebConfig,
    soundConfigWebNotification: (state) => state.soundConfigWebNotification,
    routeDetailCounter: (state) => state.routeDetailCounter,
    firstTimeRefresh: (state) => state.firstTimeRefresh,
    isBasicUser: (state) => state.isBasicUser,
    maxSpeedNotification: (state) => state.maxSpeedNotification,
    doorOpeningNotification: (state) => state.doorOpeningNotification,
    exDetentionNotification: (state) => state.exDetentionNotification,
    routeDepartureNotification: (state) => state.routeDepartureNotification,
    panicNotification: (state) => state.panicNotification,
    interfNotification: (state) => state.interfNotification,
    disconnNotification: (state) => state.disconnNotification,
    gpsLossNotification: (state) => state.gpsLossNotification,
    speedNotification: (state) => state.speedNotification,
    jsonDataPlanification: (state) => state.jsonDataPlanification,
    optimizationBody: (state) => state.optimizationBody,
    optimizationResult: (state) => state.optimizationResult,
    inputOptimization: (state) => state.inputOptimization,
    outputOptimization: (state) => state.outputOptimization,
    vehicles: (state) => state.vehicles,
    jsessionid: (state) => state.jsessionid,
    wpsid: (state) => state.wpsid,
  },
  mutations: {
    saveClientApiKey(state, key) {
      Container.set({ id: 'apiKey', value: key });
      state.clientApiKey = key;
    },
    saveSession(state, session) {
      state.session = session;
    },
    saveAccessToken(state, accessToken) {
      Container.set({ id: 'accessToken', value: accessToken });
      state.accessToken = accessToken;
    },
    saveRefreshToken(state, refreshToken) {
      Container.set({ id: 'refreshToken', value: refreshToken });
      state.refreshToken = refreshToken;
    },
    saveDateToken(state, dateToken) {
      Container.set({ id: 'dateToken', value: dateToken });
      state.dateToken = dateToken;
    },
    setClient(state, clientId) {
      Container.set({ id: 'clientId', value: clientId });
      state.clientId = clientId;
    },
    saveIdRouteFlash(state, idRoute) {
      state.idRouteFlash = idRoute;
    },
    cleanIdRouteFlash(state) {
      state.idRouteFlash = null;
    },
    saveShortCutPathOrigin(state, routePath) {
      state.shortCutPathOrigin = routePath;
    },
    cleanShortCutPathOrigin(state) {
      state.shortCutPathOrigin = null;
    },
    savePermissionUser(state, userPermissions) {
      state.permissionUser = userPermissions;
    },
    saveSubscriptionEndAt(state, data) {
      state.subscriptionEndAt = data;
    },
    saveDataAccess(state, data) {
      state.dataAccess = data;
    },
    saveIsUserReady(state, isUserReady) {
      state.isUserReady = isUserReady;
    },
    saveDateFilterFromRouteboard(state, dateFilterFromRouteboard) {
      state.dateFilterFromRouteboard = dateFilterFromRouteboard;
    },
    saveDateFilterDuringRouteboard(state, dateFilterDuringRouteboard) {
      state.dateFilterDuringRouteboard = dateFilterDuringRouteboard;
    },
    saveClientName(state, clientName) {
      Container.set({ id: 'clientName', value: clientName });
      state.clientName = clientName;
    },
    saveClient(state, client) {
      state.client = client;
    },
    saveUserId(state, userId) {
      Container.set({ id: 'userId', value: userId });
      state.userId = userId;
    },
    saveLoggedUser(state, loggedUser) {
      state.loggedUser = loggedUser;
    },
    saveRouteBoardVehicleFilter(state, routeBoardVehicleFilter) {
      state.routeBoardVehicleFilter = routeBoardVehicleFilter;
    },
    saveRouteBoardDriverFilter(state, routeBoardDriverFilter) {
      state.routeBoardDriverFilter = routeBoardDriverFilter;
    },
    saveRouteBoardOriginFilter(state, routeBoardOriginFilter) {
      state.routeBoardOriginFilter = routeBoardOriginFilter;
    },
    saveRouteBoardDestinationFilter(state, routeBoardDestinationFilter) {
      state.routeBoardDestinationFilter = routeBoardDestinationFilter;
    },
    saveRouteBoardRouteNameFilter(state, routeBoardRouteNameFilter) {
      state.routeBoardRouteNameFilter = routeBoardRouteNameFilter;
    },
    saveRouteBoardRouteStatusFilter(state, routeBoardRouteStatusFilter) {
      state.routeBoardRouteStatusFilter = routeBoardRouteStatusFilter;
    },
    saveRouteBoardRouteIdFilter(state, routeBoardRouteIdFilter) {
      state.routeBoardRouteIdFilter = routeBoardRouteIdFilter;
    },
    saveRouteBoardDocumentNumberFilter(state, routeBoardDocumentNumberFilter) {
      state.routeBoardDocumentNumberFilter = routeBoardDocumentNumberFilter;
    },
    saveInitDateFrom(state, initDateFrom) {
      state.initDateFrom = initDateFrom;
    },
    saveInitDateTo(state, initDateTo) {
      state.initDateTo = initDateTo;
    },
    saveTimeZone(state, timeZone) {
      state.timeZone = timeZone;
    },
    saveNewEvent(state, newEvent) {
      state.newEvent = newEvent;
    },
    saveNotificationConfig(state, notificationConfig) {
      state.notificationConfig = notificationConfig;
    },
    saveSoundConfig(state, soundConfig) {
      state.soundConfig = soundConfig;
    },
    saveNotificationWebConfig(state, notificationWebConfig) {
      state.notificationWebConfig = notificationWebConfig;
    },
    saveSoundConfigWebNotification(state, soundConfigWebNotification) {
      state.soundConfigWebNotification = soundConfigWebNotification;
    },
    saveRouteDetailCounter(state, routeDetailCounter) {
      state.routeDetailCounter = routeDetailCounter;
    },
    saveFirstTimeRefresh(state, firstTimeRefresh) {
      state.firstTimeRefresh = firstTimeRefresh;
    },
    saveIsBasicUser(state, isBasicUser) {
      state.isBasicUser = isBasicUser;
    },
    savemaxSpeedNotification(state, maxSpeedNotification) {
      state.maxSpeedNotification = maxSpeedNotification;
    },
    savedoorOpeningNotification(state, doorOpeningNotification) {
      state.doorOpeningNotification = doorOpeningNotification;
    },
    saveexDetentionNotification(state, exDetentionNotification) {
      state.exDetentionNotification = exDetentionNotification;
    },
    saverouteDepartureNotification(state, routeDepartureNotification) {
      state.routeDepartureNotification = routeDepartureNotification;
    },
    savepanicNotification(state, panicNotification) {
      state.panicNotification = panicNotification;
    },
    saveinterfNotification(state, interfNotification) {
      state.interfNotification = interfNotification;
    },
    savedisconnNotification(state, disconnNotification) {
      state.disconnNotification = disconnNotification;
    },
    savegpsLossNotification(state, gpsLossNotification) {
      state.gpsLossNotification = gpsLossNotification;
    },
    savespeedNotification(state, speedNotification) {
      state.speedNotification = speedNotification;
    },
    setMetaData(state, jsonDataPlanification) {
      if (jsonDataPlanification === null) {
        // Si es null, resetea el jsonData a un objeto vacío
        state.jsonDataPlanification = {};
      } else {
        // Si es válido, combina los datos
        state.jsonDataPlanification = {
          ...state.jsonDataPlanification,
          ...jsonDataPlanification,
        };
      }
    },
    setOptimizationBody(state, optimizationBody) {
      state.optimizationBody = optimizationBody;
    },
    setOptimizationResult(state, optimizationResult){
      state.optimizationResult = optimizationResult;
    },
    setInputOptimization(state, inputOptimization) {
      state.inputOptimization = inputOptimization;
    },
    setOututOptimization(state, outputOptimization) {
      state.outputOptimization = outputOptimization;
    },
    setVehicles(state, vehicles){
      state.vehicles = vehicles;
    }
  },
  actions: {},
  modules: {},
});
